import {PlusCircle} from 'lucide-react';
import {Button} from '@/shadcn_components/ui/button';
import useDialogState from '@/hooks/useDialogState';
import ConversationForm from '../conversation-form';
import {CreateDialog} from '@/components/refinedev/dialogs/create-dialog';
import {useContext} from 'react';
import {ConversationContext} from '../types';
import { ConversationMemberArrayInput } from './conversation-members-dialog';

export const CreateConversationButton = () => {
  const {owner_type, owner_id, refetchConversations} = useContext(ConversationContext);
  const dialogState = useDialogState();
  const transformBeforeSave = data => {
    const newData = ConversationForm.transformBeforeSave(data);
    newData[owner_type + '_id'] = owner_id;
    // newData.owner_type = owner_type;
    // newData.owner_id = owner_id;
    return newData;
  };

  return (
    <>
      <Button variant="ghost" type="button" size="icon" onClick={dialogState.openDialog}>
        <PlusCircle className="size-4" />
      </Button>
      <CreateDialog
        dialogState={dialogState}
        resource={'conversations'}
        title="Tạo cuộc trao đổi"
        transformBeforeSave={transformBeforeSave}
        formProps={{
          refineCoreProps: {
            onMutationSuccess: refetchConversations,
          },
        }}>
        <div className="flex flex-col gap-4">
          <ConversationForm.GeneralInfo />
          <ConversationMemberArrayInput source="members" />
        </div>
      </CreateDialog>
    </>
  );
};
